
import Vue from 'vue'
import VueI18n from 'vue-i18n'
//引入UI框架语言配置---elementui
import ElementLocale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang导入Element的语言包 英文
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang g导入Element的语言包 中文
//引入自定义语言配置
import enLocale from './en' // 导入项目中用到的英文语言包
import zhLocale from './zh'// 导入项目中用到的中文语言包

ElementLocale.i18n((key, value) => i18n.t(key, value)) //为了实现element插件的多语言切换
Vue.use(VueI18n)

const messages = {
  en: {  //英文语言包
    ...enLocale,
    ...elementEnLocale
  },
  zh: { // 中文语言包
    ...zhLocale,
    ...elementZhLocale,
  },
}

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 将语言标识存入localStorage或sessionStorage中，页面刷新不会默认中文显示
  messages, // 设置全局当地语言包,
  fallbackLocale: 'zh',// 指定的locale没有找到对应的资源或当前语种不存在时，默认设置当前语种为中文
  numberFormats:{ //设置 数字本地化
    'en': {
      currency: { //添加 $
        style: 'currency', currency: 'USD'
      }
    },
    'zh': {
      currency: { //添加 ￥
        style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'
      }
    }
  },
  dateTimeFormats:{//设置 日期时间本地化
    'en': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    },
    'zh': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    }
  },
  silentTranslationWarn: true, //解决vue-i18n黄色警告"value of key 'xxx' is not a string"和"cannot translate the value of keypath 'xxx'.use the value of keypath as default",可忽略
  globalInjection: true, // 全局注入
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js